import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Item as DxMenuItem } from 'devextreme/ui/menu';
import { DxMenuModule } from 'devextreme-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-language-selector',
    imports: [CommonModule, DxMenuModule, RouterModule],
    templateUrl: './language-selector.component.html',
    styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
    readonly translate: TranslateService = inject(TranslateService);

    menuLang!: DxMenuItem[];

    constructor() {
        const buildMenuLang = () => {
            this.menuLang = [
                {
                    icon: 'fa-solid fa-language fa-fw fa-lg',
                    items: this.translate.getLangs()?.map((lang) => ({
                        text: this.translate.instant(`LANG.${lang.toUpperCase()}.NAME`),
                        linkAttr: { lang },
                        selected: this.translate.getCurrentLang() === lang,
                        template: 'linkTemplate',
                    })),
                },
            ];
        };

        this.translate.onLangChange.subscribe((val) => {
            buildMenuLang();
        });

        buildMenuLang();
    }
}
